<template>
    <section class="hero is-fullheight">
        <div id="context_bar"></div>
        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1">{{ $t('modules.auth.profile.title') }}</h1>
            </template>
        </titlePage>
        <div id="index_positions_content" class="hero flex">
            <div class="hero-body flex_content">
                <div class="container">

                <div class="settings_form" v-if="this.uSettings.settings">
                    <div class="setting_section">
                        <h3>{{ $t('modules.auth.profile.settingsTitle') }}</h3>

                        <div class="columns">
                            <div class="column">
                                <h4>{{ $t('modules.auth.profile.settingsManageSubtitle') }}</h4>

                                <div class="notification is-inverse">
                                    {{ $t('modules.auth.profile.settingsManageNotice1') }}
                                    <br><br>
                                    <a target="_blank" :href="accountLink" class="button is-info is-outlined ">{{ $t('modules.auth.profile.settingsManageButton') }}</a>
                                </div>

                                <div class="notification is-inverse" v-html="$t('modules.auth.profile.settingsManageNotice2')"></div>


                            </div>
                            <div class="column is-5">
                                <h4>{{ $t('modules.auth.profile.accessTitle') }} : {{ $t(currentPackTranslation) }}</h4>
                                <div class="evals_remaining_start_pack" v-if="isStart">
                                    <h4>{{ remainingEvals }} {{ $t('modules.auth.profile.evalsRemaining') }}</h4>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="setting_section">
                        <h3>{{ $t('modules.auth.profile.notifsTitle') }}</h3>
                        <SwitchInput switchId="evaluation_notif"
                            :switchLabel="$t('modules.auth.profile.notifsRadioLabel')"
                            :value="valToBool(this.uSettings.settings.customisation.evaluation_notif)"
                            @change="handleSwitch" />
                    </div>
                    <div class="setting_section" >
                            <h3>{{ $t('modules.auth.profile.customTitle') }}</h3>
                            <div class="columns" v-if="canAccessCustomisation">
                                <div class="column">
                                    <h4>{{ $t('modules.auth.profile.customLogoSubtitle') }}</h4>
                                    <SwitchInput switchId="logo_email_enabled"
                                        :switchLabel="$t('modules.auth.profile.customLogoRadio1Label')"
                                        :value="valToBool(this.uSettings.settings.customisation.logo_email_enabled)"  
                                        @change="handleSwitch" />

                                    <SwitchInput switchId="logo_report_enabled" 
                                        :switchLabel="$t('modules.auth.profile.customLogoRadio2Label')"
                                        :value="valToBool(this.uSettings.settings.customisation.logo_report_enabled)"  
                                        @change="handleSwitch" />
                                </div>
                                <div class="column">
                                    <h4>{{ $t('modules.auth.profile.customEmailSubtitle') }}</h4>
                                    <SwitchInput switchId="email_custom_enabled"
                                        :switchLabel="$t('modules.auth.profile.customEmailRadioLabel')"
                                        :value="valToBool(this.uSettings.settings.customisation.email_custom_enabled)"
                                        @change="handleSwitch" />


                                    <InputMaterialWrap
                                        v-model="emailSubject"
                                        :label="$t('modules.auth.profile.customEmailSubjectLabel')"
                                        input-id="contactEmailSubject"
                                        @input="updateFormData"
                                    />

                                    <TextareaMaterialWrap
                                        v-model="emailContent"
                                        :label="$t('modules.auth.profile.customEmailContentLabel')"
                                        input-id="contactEmailContent"
                                        @input="updateFormData"
                                        />

                                </div>
                            </div>
                            <div v-else>
                                <div class="notification is-danger">
                                    {{ $t('modules.auth.profile.notifError') }}
                                </div>
                            </div>

                        </div>

                    </div>

                    <button type="button" class="button is-outlined is-info" @click="saveSettings" >{{ $t('modules.auth.profile.saveButton') }}</button>

                </div>

                <transition name="notif-slide-up">
                    <alert class="login_notif" v-if="showSuccessNotif" context="success" @close="showSuccessNotif=false">
                        {{ $t('modules.auth.profile.notifSuccess') }}
                    </alert>
                </transition>

            </div>
        </div>
    </section>
</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {

    name: 'Profile',
    components: {
        TitlePage
    },
    data(){
        return {
            emailSubject: '',
            emailContent: '',
            evaluation_notif: false,
            logo_email_enabled: false,
            logo_report_enabled: false,
            email_custom_enabled: false,
            canAccessCustomisation: userCanAccess('extra', 'customisation'),
            CanAccess: userCanAccess,
            uAccess: JSON.parse(localStorage.getItem('account')),
            showSuccessNotif: false
        }
    },
    mounted(){
        this.$store.dispatch("UserStore/getSettings").then( (data) => {
            this.emailSubject = this.uSettings.settings.customisation.email_custom_subject
            this.emailContent = this.uSettings.settings.customisation.email_custom_content
            this.evaluation_notif = this.uSettings.settings.customisation.evaluation_notif == '1' ? true : false ,
            this.logo_email_enabled = this.uSettings.settings.customisation.logo_email_enabled == '1' ? true : false ,
            this.logo_report_enabled = this.uSettings.settings.customisation.logo_report_enabled == '1' ? true : false ,
            this.email_custom_enabled = this.uSettings.settings.customisation.email_custom_enabled == '1' ? true : false
        })
    },
    computed: {
        currentUser(){
            const user = localStorage.getItem('user');
            return JSON.parse(user)
        },
        uSettings(){
            return this.$store.state.UserStore.userSettings
        },
        accountLink(){
            return `${process.env.VUE_APP_AXIOS_BASE_URL}user_account/login/new?language=${this.$i18n.locale}&account_token=${this.uSettings.account_token}`
        },
        currentPack() {
            return this.uAccess.contract.subscription_plan;
        },
        currentPackTranslation() {
            return 'modules.auth.profile.currentPack.' + this.currentPack;
        },
        isStart() {
            return this.currentPack == 'start'
        },
        isCustom() {
            return this.currentPack == 'custom'
        },
        remainingEvals() {
            return this.uAccess.licence.evaluations_remaining;
        }
    },
    methods: {
        valToBool(val){
            return (val == "1" || val == true)
        },
        handleSwitch(id, value){
            if (id == 'evaluation_notif'){ this.evaluation_notif = value }
            if (id == 'logo_email_enabled'){ this.logo_email_enabled = value }
            if (id == 'logo_report_enabled'){ this.logo_report_enabled = value }
            if (id == 'email_custom_enabled'){ this.email_custom_enabled = value }
        },
        saveSettings(){
            const settings = {
                sight_settings: {
                    customisation: {
                        email_custom_content: this.emailContent,
                        email_custom_enabled: (this.valToBool(this.email_custom_enabled) ? "1": "0"),
                        email_custom_subject: this.emailSubject,
                        evaluation_notif: (this.valToBool(this.evaluation_notif) ? "1": "0"),
                        logo_email_enabled: (this.valToBool(this.logo_email_enabled) ? "1": "0"),
                        logo_report_enabled: (this.valToBool(this.logo_report_enabled) ? "1": "0")
                    }
                }
            }
            this.$store.dispatch('UserStore/updateProfile', settings).then( (resp) => {
                this.showSuccessNotif = true
            })
        },
        updateFormData(){

        }
    }
}

</script>

<style lang="scss">
.setting_section{
    padding-bottom: 30px;
    h3{
        font-size: 1.75rem;
        margin: 18px 0;
        border-bottom: 1px solid $grey-lighter;

    }
    h4{
        font-weight: 600;
        color: $info;
        font-size: 1.25rem;
        margin: 12px 0;
    }
    .input, textarea, .notification{
        border-radius: 6px;
    }
    .field{
        margin-bottom: 30px!important;
    }
    .access_list{
        li{
            display: flex;
            align-items: center;
            .boolean_icon{
                margin-right: 8px;
            }
            span{
                font-size: 1.15rem;
            }
        }
    }
}
.evals_remaining_start_pack{
    h4{
        color: black!important;
        font-size: 1.2rem;
        line-height: 1rem;
    }
}
</style>
